/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

import { validateContainersObject } from './validateContainersObject';

// the validation logic is documented here
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/545900273/Validating+containers+object
export function validateContainers(containers: any): void {
	if (!containers) {
		return;
	}

	if (containers && containers.constructor !== Object) {
		throw new Error('properties.containers must be an Object');
	}

	Object.values(containers).forEach((container) => validateContainersObject(container));
}
